import urls from './urls.json';

const authUrlFromEnv = window.AUTH_URL;

export default authUrlFromEnv || urls.authUrl;
